"use scrict";

global.$ = require("jquery");
var MobileDetect = require('mobile-detect');

global.md = new MobileDetect(window.navigator.userAgent);
var mainWidth;

global.remToPx = function(x){
  return (parseInt($('html').css('font-size')) * x);
}

var Macy = require('macy');
var Masonry = require('masonry-layout');

$(function(){
  vh();

  setTimeout(function(){
    $('body').addClass('in');

    // $('video').each(function(){
    //   if(this.paused) {
    //     $(this).addClass('paused');
    //   }
    // });
  }, 10);

  treats();

  binds();

  $(window).on('pageshow', function(){
    $(window).trigger('scroll');
    $('body').removeClass('out').addClass('in');
  });

  setTimeout(function(){
    if(!window.treatsDone) {
      treats();
    }
  }, 500)
});

function treats(){
  window.treatsDone = true;

  // $('.heading span').each(function(){
  //   var split = [];
  //   if($(this).text().indexOf(' - ')>=0) {
  //     split = $(this).text().split(' - ');
  //   }
  //   if($(this).text().indexOf(' – ')>=0) {
  //     split = $(this).text().split(' – ');
  //   }
  //   if($(this).text().indexOf(' – ')>=0) {
  //     split = $(this).text().split(' – ');
  //   }

  //   if(split.length>1) {
  //     $(this).html(split[0]+` <strong>${split[1]}</strong>`);
  //   }
  // });
  
  $('.block--text, .heading').each(function(){
    if($(this).find('a').length>1){
      var link = $(this).find('a').first().attr('href');
      $(this).find('a').contents().unwrap();
      $(this).contents().wrap(`<a href='${link}'></a>`);
    }
    $(this).children().each(function(){
      if($(this).text().trim().length==0) $(this).remove();
    });
  });

  if($('html').hasClass('photoproject')) {
    $('.header a[href*="photo"]').addClass('cur');
  }

  if($('html').hasClass('project')) {
  
    if(window.location.href.indexOf('commercials')>=0) {
      $('.header a[href*="commercial"]').addClass('cur');
    }

    if(window.location.href.indexOf('films')>=0) {
      $('.header a[href*="film"]').addClass('cur');
    }
  }

  // if($('.category-film').length>0) {
    // let firstPostImageUrl = $('[data-thumb-url]').first().attr('data-thumb-url');
    // $('[property="og:image"]').attr('content', firstPostImageUrl);
  // }

  if($('.category-photo').length>0) {
    // let firstPostImageUrl = $('[data-thumb-url]').first().attr('data-thumb-url');
    // $('[property="og:image"]').attr('content', firstPostImageUrl);
    if(!window.msnry){
      window.msnry = new Masonry( '.main--wrap', {
        // options...
        itemSelector: '.photoproject',
        percentPosition: true,
        columnWidth: '.grid-size',
        gutter: window.innerWidth < 787 ? 3 : remToPx(.5),
        transitionDuration: 0
      });
      
      $(window).on('resize', function(){
        if(!md.isMobile()) {
          if(msnry) msnry.destroy();
          
          window.msnry = new Masonry( '.main--wrap', {
            // options...
            itemSelector: '.photoproject',
            percentPosition: true,
            columnWidth: '.grid-size',
            gutter: window.innerWidth < 787 ? 3 : remToPx(.5),
            transitionDuration: 0
          });
        }
      });
      
      $('.photoproject img').each(function(idx){
        var t = this; 
        setTimeout(function(){
          t.onload = $(t).addClass('ok');
        }, 30 * idx);
      });
    }
  }
}


function binds(){
  // if(md.mobile()) {
  //   window.prevScr = $(window).scrollTop();
  //   window.scrPlus = 0;

  //   $(window).on('scroll', function(){
  //     let curScr = $(window).scrollTop();
  //     if(curScr < window.prevScr || curScr < 50) {
  //       window.scrPlus = 0;
  //       $('.header').removeClass('fold');
  //     } else {
  //       window.scrPlus++;
  //       if(window.scrPlus > 20) {
  //         $('.header').addClass('fold');
  //       }
  //     }
  //     window.prevScr = $(window).scrollTop();
      
  //   });
  // }

  $('.photoproject body').on('click', function(e){
    if(e.target == $('body').get(0)) {
    $('body').addClass('out');
      $('.back--link').click();
      // setTimeout(function(){
        // window.history.back();
      // }, 400);
    }
  });

  $('.home .block--text').each(function(){
    if($(this).find('a').length>0) {
      $(this).find('p > *').on('mouseenter', function(){
        $(this).parents('.block--text').addClass('hover');
      }).on('mouseleave', function(){
        $(this).parents('.block--text').removeClass('hover');
      });
    }
  });

  $(document).on('keyup', function(e){
    if(e.keyCode==27 && $('.back--link').length>0) {
      $('.back--link').click();
    }
  });

  $('a[href*="'+window.siteurl+'"]').on('click', function(e){
    if (!e) e = window.event;
    if (!e.shiftKey &&
      !e.altKey &&
      !e.ctrlKey &&
      !e.metaKey) {
        e.preventDefault();
        $('body').addClass('out');
        var href = $(this).attr('href');
        setTimeout(function(){
          window.location = href;
        }, 350);
      }
  });

  $('.back--link').on('click', function(e){
    e.preventDefault();
    $('body').addClass('out');
    var href = $(this).attr('href');
    setTimeout(function(){
      window.location = href;
    }, 350);
  });

  $('.menu-button').on('click', function(e){
    e.preventDefault();
    $('.header').toggleClass('nav-in').removeClass('fold');
  });

  $('.mobile-menu').on('click', function(e){
    if(!$(e.target).is('a') && $(e.target).parents('a').length==0) {
      $('.header').removeClass('nav-in').removeClass('fold');
    }
  });

  // $('.main--wrap p').each(function(){
  //   var h = $(this).html();
  //   var svg = $('.logo > svg').clone();
  //   $(svg).css({
  //     'height': '0.65em',
  //     'margin-right': '0.15em',
  //     'vertical-align': '-0.05em',
  //   });
  //   svg = svg.get(0).outerHTML;
  //   h = h.replaceAll('<strong>mose</strong>', svg);
  //   $(this).html(h);
  // });

  if($('html').hasClass('artist')) {
    $(window).on('scroll', function(){
      var top = $(window).scrollTop();
      if(top > $('.projects').position().top + remToPx(8)){
        $('.banner').addClass('w');
      } else {
        $('.banner').removeClass('w');
      }

      if(top + window.innerHeight > document.scrollingElement.scrollHeight - remToPx(7)){
        $('.footer').addClass('d');
      } else {
        $('.footer').removeClass('d');
      }
    });

    $('.block--image img').on('click', function(){
      $('html').addClass('no-overflow');
      $('body').append('<div class="pop"><div class="pop--content"></div></div>');
      $('.pop--content').append($(this).clone());
      $('.pop').on('click', function(e){
        if(e.target==this) {
          $('.pop').remove();
        }
      });
    });
  }

  window.titles = [];
  if($('html').hasClass('home')) {
    window.titles = $('.block--text');
  } else {
    window.titles = $('.heading');
  }

  $(window.titles).each(function(){

  });

  $(window).on('scroll', function(){
    if(window.innerWidth>=1400) {
      for(var i=0;i<window.titles.length;i++) {
        var t = window.titles[i];
        var rect = t.getBoundingClientRect();
        var inview = rect.top < window.innerHeight*.5 + remToPx(4);
        if(inview){
          $('.cur-title').html($(t).html());
        }
      }
    }

    $('video:not(.ok)').each(function(){
      if(this.getBoundingClientRect().top < window.innerHeight * 2) {
        $(this).children().attr('src', $(this).children().attr('data-src'));
        this.load();
        $(this).addClass('ok');
      }
    });
  });

  $(window).trigger('scroll');
}

function vh(){
  window.vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${window.vh}px`);
  $('#menuhooks.mobonly').css('top', $('.nav').outerHeight());
}

function resize(){
  let newMainWidth = $('main').outerWidth();
  if(newMainWidth!==mainWidth || !md.mobile()){
    vh();
  }
  mainWidth = newMainWidth;
}

$(window).on('resize', resize);

/*
function textFits(){
  $('.textfit').each(function(){
      var tar = $(this).parent();

      var h = $(this).parent().outerHeight();
      var w = $(this).parent().outerWidth();

      $(this).css({
        // 'height' : parseInt(h),
        'width' : parseInt(w),
      });

      var t = this;
      setTimeout(function(){
        textFit(
          t,
          {
            multiLine: true,
            minFontSize: 12,
            maxFontSize: remToPx(2.25),
            widthOnly: true,
          }
        );
      },1);
  });
}

window.textFits = textFits;
*/